import PackageInfo from '../../package.json';

export default defineNuxtPlugin({
  name: 'mylhs-app',
  setup() {
    const app = {
      name: PackageInfo.productName,
      version: PackageInfo.version,
      description: PackageInfo.description,
      author: PackageInfo.author,
    }
    return {
      provide: {
        app
      }
    }
  },
  hooks: {
    'app:mounted': () => {
      const system = useSystemStore();
      system.setLoaded(true);
    }
  }
})
